export const createUppPath = (
  shoppingBasketToken: string,
  onSuccessUrl,
  additionalParams = ''
): string => {
  const encodedOnSuccessUrl = encodeURIComponent(onSuccessUrl);
  return `/travel/extras/#checkout/${shoppingBasketToken}/${encodedOnSuccessUrl}/${additionalParams}`;
};

export const HOME_PAGE = '/home/';

export const TRIP_DETAILS_PAGE = '/travel/secure/#tripdetails/';
